"use client";

import {
  DEAL_TYPES,
  type DealType,
  type DealTypeCategory,
} from "@/lib/dealTypes";
import { listingFormStyles as s } from "./listingFormStyles";
import { FieldError } from "./ListingFormFields";
import { theme } from "@/lib/uiTheme";

type Props = {
  value: DealType | "";
  onChange: (value: DealType) => void;
  disabled?: boolean;
  error?: string;
};

const GROUPS: { category: DealTypeCategory; label: string }[] = [
  { category: "traditional", label: "Traditional" },
  { category: "creative", label: "Creative Financing" },
  { category: "other", label: "Other" },
];

export default function DealTypeSelector({
  value,
  onChange,
  disabled,
  error,
}: Props) {
  const selected = DEAL_TYPES.find((type) => type.value === value);

  return (
    <div style={s.field}>
      {GROUPS.map(({ category, label }) => (
        <fieldset
          key={category}
          disabled={disabled}
          style={{ border: 0, padding: 0, margin: "0 0 16px" }}
        >
          <legend style={{ ...s.label, marginBottom: 8 }}>{label}</legend>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
              gap: 8,
            }}
          >
            {DEAL_TYPES.filter((type) => type.category === category).map(
              (type) => {
                const isSelected = value === type.value;
                return (
                  <label
                    key={type.value}
                    htmlFor={`listing-deal-type-${type.value}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "10px 12px",
                      border: `1px solid ${isSelected ? theme.colors.primary : theme.colors.border}`,
                      borderRadius: theme.radii.lg,
                      background: isSelected
                        ? theme.colors.primaryMuted
                        : theme.colors.surface,
                      color: theme.colors.ink,
                      cursor: disabled ? "not-allowed" : "pointer",
                    }}
                  >
                    <input
                      id={`listing-deal-type-${type.value}`}
                      name="deal_type"
                      type="radio"
                      value={type.value}
                      checked={isSelected}
                      onChange={() => onChange(type.value)}
                      style={{ accentColor: theme.colors.primary }}
                    />
                    <span style={{ fontSize: 14, fontWeight: 600 }}>
                      {type.label}
                    </span>
                  </label>
                );
              },
            )}
          </div>
        </fieldset>
      ))}
      {selected ? (
        <p style={{ ...s.sectionHint, marginBottom: 0 }}>
          {selected.shortHelp}
        </p>
      ) : null}
      <FieldError message={error} />
    </div>
  );
}
